import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  hasTelegramLaunchContext,
  loadTelegramSdk,
  prepareTelegramMiniApp,
  telegramWebApp,
} from "../platform/telegram.js";

export function TelegramRuntimeBridge() {
  const location = useLocation();
  const navigate = useNavigate();
  const [webApp, setWebApp] = useState(() => telegramWebApp());

  useEffect(() => {
    if (webApp || !hasTelegramLaunchContext()) return undefined;
    let cancelled = false;
    void loadTelegramSdk().then((loaded) => {
      if (!cancelled && loaded) setWebApp(loaded);
    });
    return () => { cancelled = true; };
  }, [webApp]);

  useEffect(() => prepareTelegramMiniApp(webApp), [webApp]);

  useEffect(() => {
    const backButton = webApp?.BackButton;
    if (!backButton) return undefined;
    const atRoot = location.pathname === "/" && !location.search && !location.hash;
    const goBack = () => navigate(-1);
    if (atRoot) {
      backButton.hide?.();
    } else {
      backButton.show?.();
      backButton.onClick?.(goBack);
    }
    return () => backButton.offClick?.(goBack);
  }, [location.hash, location.pathname, location.search, navigate, webApp]);

  return null;
}
